const pendingSignupStorageKey = 'budgy:pending-signup-conversion';

/**
 * Survives the full reload after sign-up, so ad conversions fire on the next
 * page instead of racing the navigation that would cancel them.
 */
export const markPendingSignupConversion = (userId: string): void => {
  window.sessionStorage.setItem(pendingSignupStorageKey, userId);
};

/** Reads and clears the pending sign-up, returning the new user's id. Client-only. */
export const consumePendingSignupConversion = (): string | null => {
  const userId = window.sessionStorage.getItem(pendingSignupStorageKey);
  window.sessionStorage.removeItem(pendingSignupStorageKey);

  return userId;
};
